/**
 * Feed-level constants shared by every preview section, pinned from
 * the mobile apps. Section-specific geometry stays with its section.
 */

/** Logical device width the preview renders at; crops are proportional. */
export const DEVICE_WIDTH = 360;
/** Logical device height (9:20). The frame is laid out at this size and
 * scaled as a whole, so typography and gutters keep their proportions. */
export const DEVICE_HEIGHT = 800;
/** BannerSection.kt — the feed's horizontal padding. */
export const GUTTER = 16;

/**
 * Horizontal geometry is expressed against the frame's own width rather
 * than in pixels, so it survives any future change to the logical width.
 */
export const asDeviceWidth = (px: number): string =>
  `${(px / DEVICE_WIDTH) * 100}%`;

/** Mobile surface colors — exempt from the no-hex rule, they replicate the phone theme. */
export const MOBILE_SURFACE = {
  light: '#F3EFE9',
  dark: '#202020',
} as const;

/** What shows behind a creative while it loads, or when it fails to. */
export const MOBILE_PLACEHOLDER = {
  light: '#E2DBD1',
  dark: '#2E2E2E',
} as const;

export const MOBILE_TEXT = {
  light: '#111111',
  dark: '#FFFFFF',
} as const;

export type MobileTheme = keyof typeof MOBILE_SURFACE;
